import { createFileRoute, defer } from '@tanstack/react-router';

import { HomePageView } from '@/components/site/pages';
import { seoHead } from '@/lib/seo';
import { SITE_DESCRIPTION, SITE_HOME_TITLE } from '@/lib/site-url';
import { loadHomePage, loadHomePageDeferred } from '@/server/functions/pages';

export const Route = createFileRoute('/')({
    staleTime: 5 * 60_000,
    loader: async () => {
        const core = await loadHomePage();
        return {
            ...core,
            deferred: defer(loadHomePageDeferred()),
        };
    },
    head: () =>
        seoHead({
            title: SITE_HOME_TITLE,
            description: SITE_DESCRIPTION,
            path: '/',
        }),
    component: HomePage,
});

function HomePage() {
    const data = Route.useLoaderData();
    return <HomePageView {...data} />;
}
